export enum PrescriptionCountEnum {
  LESS_THAN_THREE = '<3',
  THREE_TO_FIVE = '3-5',
  SIX_TO_TEN = '6-10',
  ELEVEN_PLUS = '11+',
}
